import App from 'app/app.js';
import 'app/directive/LtOrderSummaryZeroStateDirective.js';

function LtOrderSummaryZeroStateCtrl($scope, RouterService) {
  this.goToPackages = function () {
    RouterService.goToPackages();
  };

  this.addNewStudent = function () {
    $scope.addNewStudent();
  };
}

App.controller('LtOrderSummaryZeroStateCtrl', ['$scope', 'RouterService', LtOrderSummaryZeroStateCtrl]);
